export const COOKIE = {
  JSESSIONID: 'JSESSIONID',
  AWSALB: 'AWSALB',
  AWSALBCORS: 'AWSALBCORS',
  BOOKMARKID: 'BOOKMARKID',
  HISTORYID: 'HISTORYID',
  HISTORY_ID_CA: 'HISTORY_ID_CA',
  DESIRED_COND: 'desired_cond',
  DESIRED_SEARCH: 'desired_search',
  TUTOR_MODAL: 'tutorModal',
  SESSION: 'SESSION',
  SEARCH_CONDITION1: 'search_condition1',
  SEARCH_CONDITION2: 'search_condition2',
  SEARCH_CONDITION3: 'search_condition3',
  SID: 'sid',
  AUTO_LOGIN: 'auto_login',
  LATEST_SEARCH: 'latest_search',
  VIEW_MODE: 'viewmode',
  PRE_PAGE_ID: 'prePageId',
  OUTPUT_STAFF_INFO: 'output_staff_info',
  IS_UPDATED_WEB_RESUME: 'is_updated_web_resume',
  IS_UPDATED_WORK_EXPERIENCE: 'is_updated_work_experience',
  IS_UPDATED_WEB_RESUME_TARGET_COUNSELING:
    'is_updated_web_resume_target_counseling',
};
